export default "__VITE_ASSET__Mm02xrhV__"